export default "__VITE_ASSET__CMnNjHS8__"